import React from 'react';
import { Col, Row } from 'antd';
import { I18n } from '@aws-amplify/core';

import type { BeraResultInformations } from '@/types/Bera';

import { Details } from './Details';
import { ResultsCard } from './ResultsCard';
import { Hairline } from '../styles';
import { HeaderSubtitle, HeaderTitle, Logo, VerticalDivider } from './styles';

const LOGO_URL = 'https://kinebot-statics.s3.amazonaws.com/kinebot_logo.png';
const HEADER_GUTTER = 80;
const BLOCK_GUTTER = 32;
const COLUMN_GUTTER = 40;
const FULL_SPAN = 24;
const INFO_SPAN = 17;
const DIVIDER_SPAN = 1;
const RESULTS_SPAN = 6;

interface InformationsProps {
	informations: BeraResultInformations;
	isEns: boolean;
}

export function Informations({ informations, isEns }: Readonly<InformationsProps>): JSX.Element {
	return (
		<Row gutter={[0, BLOCK_GUTTER]}>
			<Col span={FULL_SPAN}>
				<Row align="middle" gutter={[HEADER_GUTTER, 0]} wrap={false}>
					<Col>
						<Logo src={LOGO_URL} alt="Kinebot" />
					</Col>
					<Col flex="auto">
						<HeaderSubtitle>{I18n.get('Result')}</HeaderSubtitle>
						<HeaderTitle>{I18n.get('Cycle scores - B.E.R.A.')}</HeaderTitle>
					</Col>
				</Row>
			</Col>
			<Col span={FULL_SPAN}>
				<Hairline />
			</Col>
			<Col span={FULL_SPAN}>
				<Row gutter={[COLUMN_GUTTER, 0]} wrap={false}>
					<Col span={INFO_SPAN}>
						<Details informations={informations} />
					</Col>
					<Col span={DIVIDER_SPAN}>
						<VerticalDivider />
					</Col>
					<Col span={RESULTS_SPAN}>
						<ResultsCard
							totalTime={informations.total_time}
							overallScore={informations.overall_score}
							isEns={isEns}
						/>
					</Col>
				</Row>
			</Col>
			<Col span={FULL_SPAN}>
				<Hairline />
			</Col>
		</Row>
	);
}
